<template>
  <a
    class="Material"
    :class="{ 'Material--selected': selected, 'Material--grid': gridView }"
    :href="data.file"
    @click="handleClickLink"
    target="_blank"
  >
    <div class="Material__line">
      <div v-if="isImage" class="Material__image">
        <img :src="data.file" loading="lazy" alt="">
      </div>
      <div v-else-if="isVideo" class="Material__image">
        <video ref="videoEl" :src="data.file" :controls="isPlayed" loading="lazy" />
        <svg v-if="!isPlayed" @click="playVideo" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.79785 7.71566V17.2857C5.79785 19.2457 7.92785 20.4757 9.62785 19.4957L13.7779 17.1057L17.9279 14.7057C19.6279 13.7257 19.6279 11.2757 17.9279 10.2957L13.7779 7.89566L9.62785 5.50566C7.92785 4.52566 5.79785 5.74566 5.79785 7.71566Z" fill="white"/>
        </svg>
      </div>
      <div v-else-if="isAudio" class="Material__preview">
        <svg width="20" height="20" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.3501 33.3333V46.6666C11.3501 53.3333 14.6834 56.6666 21.3501 56.6666H26.1168C27.3501 56.6666 28.5834 57.0333 29.6501 57.6666L39.3834 63.7666C47.7834 69.0333 54.6834 65.1999 54.6834 55.2999V24.6999C54.6834 14.7666 47.7834 10.9666 39.3834 16.2333L29.6501 22.3333C28.5834 22.9666 27.3501 23.3333 26.1168 23.3333H21.3501C14.6834 23.3333 11.3501 26.6666 11.3501 33.3333Z" stroke="#CCD7E6" stroke-width="8.4"/>
          <path d="M68.6836 26.666C74.6169 34.566 74.6169 45.4327 68.6836 53.3327" stroke="#CCD7E6" stroke-width="8.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div v-else class="Material__preview">
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.6 1.5C3.61177 1.5 2 3.11178 2 5.1V12.9C2 14.8882 3.61178 16.5 5.6 16.5H10.8C12.7882 16.5 14.4 14.8882 14.4 12.9V7.73696C14.4 6.78218 14.0207 5.8665 13.3456 5.19137L10.7086 2.55442C10.0335 1.87928 9.11783 1.5 8.16305 1.5H5.6Z" stroke="#CCD7E6" stroke-width="2"/>
          <path d="M9.06689 1.67334L9.06689 6.48667C9.06689 6.96532 9.45491 7.35334 9.93356 7.35334H14.2269" stroke="#CCD7E6" stroke-width="2"/>
        </svg>
      </div>

      <div class="Material__name hide-mobile">
        {{ name }}
      </div>
      <div class="Material__mobile-line hide-pc">
        <div class="Material__name hide-pc">
          {{ name }}
        </div>
        <div
          class="badge hide-pc"
          :style="`background-color: ${color.bg}; color: ${color.text}`"
          v-text="data.event_type"
        />
      </div>
    </div>
    <div class="Material__date">
      {{ date }}
    </div>
    <div class="Material__type">
      {{ eventName }}
    </div>
    <div class="Material__type">
      <div
        class="badge"
        :style="`background-color: ${colorBadgeTypeEvent.bg}; color: ${colorBadgeTypeEvent.text}`"
        v-text="eventType"
      />
    </div>
    <div
      class="badge hide-mobile"
      :style="`background-color: ${color.bg}; color: ${color.text}`"
      v-if="data.event_type"
      v-text="data.event_type"
    />
    <div class="Material__actions" @click.prevent>
      <div class="Material__action-button" @click="openModal({name: 'materials-edit', options: data})">
        <img src="@/assets/icons/material-edit.svg" alt="" />
      </div>
      <div class="Material__action-button" @click="openModal({name: 'materials-delete', options: data})">
        <img src="@/assets/icons/material-delete.svg" alt="" />
      </div>
    </div>
  </a>
</template>

<script>
import Avatar from '@/components/user/Avatar'
import moment from 'moment'
import { mapActions, mapMutations } from 'vuex'
import eventUtils from '@/mixins/eventUtils'

export default {
  name: 'Material',
  components: { Avatar },
  mixins: [eventUtils],
  props: {
    data: Object,
    edit: Boolean,
    selected: Boolean,
    gridView: Boolean,
  },
  data: () => ({
    isPlayed: false,
  }),
  computed: {
    name() {
      return this.data.name.replace(/\.(\w*$)/, '')
    },
    isImage() {
      return this.data.mime_type?.includes('image');
    },
    isVideo() {
      return this.data.mime_type?.includes('video');
    },
    isAudio() {
      return this.data.mime_type?.includes('audio');
    },
    event() {
      return this.data.events?.[0];
    },
    eventName() {
      return this.event?.name ?? '-';
    },
    eventType() {
      return this.event?.type?.title ?? '-';
    },
    date() {
      return moment(this.data.added_at * 1000).format('MMM DD ∙ HH:MM')
    },
    type() {
      return this.data.file?.match(/[^.]+$/)?.[0] || ''
    },
    color() {
      switch (this.data.event_type) {
        case 'Presentation':
          return {
            bg: 'rgba(222, 135, 3, 0.1);',
            text: '#DE8703',
          }
        case 'Lecture':
          return {
            bg: 'rgba(0, 56, 130, 0.1);',
            text: '#003882',
          }
        case 'Discussion':
          return {
            bg: 'rgba(195, 67, 67, 0.1);',
            text: '#C34343',
          }
        case 'B2B':
          return {
            bg: 'rgba(0, 166, 227, 0.1);',
            text: '#00A6E3',
          }
        case 'Workshop':
          return {
            bg: 'rgba(40, 173, 132, 0.1);',
            text: '#28AD84',
          }
      }

      return {}
    },
  },
  methods: {
    ...mapActions('library', ['removeLibrary']),
    ...mapMutations(['openModal']),
    playVideo() {
      if(this.gridView) {
        this.isPlayed = true;
        this.$refs.videoEl.play();
      }
    },
    handleClickLink(e) {
      if(this.gridView) {
        if(this.isVideo) {
          e.preventDefault();
        }
      }
      this.$root.sendSignal({ ext_link: this.data.file })
    },
  },
}
</script>

<style lang="scss">
.Material {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 100px 230px 120px;
  grid-gap: 50px;
  justify-items: flex-start;
  align-items: center;
  margin-right: 70px;

  padding: 10px 0;
  z-index: 2;

  font-weight: 400;
  font-size: 15px;
  line-height: 157.5%;

  @include mobile {
    display: flex;
    flex-direction: column;
    grid-gap: unset;
    padding: 0;
    min-width: 0;
    align-items: flex-start;
    margin-right: 0;

    .Material__image {
      display: flex;
      height: 140px;
      width: 100%;
    }

    .Material__preview {
      height: 140px;
      width: 100%;

      svg {
        height: 64px;
        width: 64px;
      }
    }

    .Material__line {
      display: block;
      width: 100%;
      order: 1;

      .Material__name {
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        padding-right: 0;
      }

      > * + * {
        margin-left: 0;
        margin-top: 15px;
      }
    }

    .Material__type {
      margin-top: 2px;
      margin-bottom: 30px;
      order: 2;
      -webkit-line-clamp: 3;
    }

    .Material__date {
      position: absolute;
      left: 0;
      bottom: 0;

      font-size: 12px;
      font-weight: 600;
      line-height: 17.7px;
    }

    &:hover {
      &::before {
        content: none;
      }
    }
  }

  &,
  &:hover {
    color: #474747;
    text-decoration: none;
  }

  & + & {
    @include mobile {
      margin-top: 30px;
    }
  }

  &--selected,
  &:hover {
    &::before {
      content: '';
      position: absolute;
      top: -3px;
      bottom: -3px;
      left: -40px;
      right: -110px;
      z-index: -1;

      background: #ffffff;
      box-shadow: 0 5px 21px rgba(204, 215, 230, 0.3);
      border-radius: 13px;

      @include mobile {
        top: -10px;
        bottom: -10px;
        right: -20px;
        left: -20px;
      }
    }
  }

  &--grid {
    display: flex;
    flex-direction: column;
    grid-gap: unset;
    padding: 0;
    min-width: 0;
    align-items: flex-start;
    margin-right: 0;

    .Material__image {
      width: 100%;
      height: 174px;

      @include mobile {
        height: 140px;
      }

      svg {
        height: 92px;
        width: 92px;
      }
    }

    .Material__preview {
      width: 100%;
      height: 174px;

      @include mobile {
        height: 140px;
      }

      svg {
        height: 64px;
        width: 64px;
      }
    }

    .Material__line {
      display: block;
      width: 100%;
      order: 1;

      .Material__name {
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        padding-right: 0;
      }

      > * + * {
        margin-left: 0;
        margin-top: 15px;
      }
    }

    .Material__type {
      margin-top: 2px;
      margin-bottom: 38px;
      order: 2;
      -webkit-line-clamp: 3;

      @include mobile {
        margin-bottom: 30px;
      }
    }

    .Material__date {
      position: absolute;
      left: 0;
      bottom: 0;

      @include mobile {
        font-size: 12px;
        font-weight: 600;
        line-height: 17.7px;
      }
    }

    .badge {
      position: absolute;
      right: 0;
      bottom: 0;

      @include mobile {
        position: relative;
        right: unset;
        bottom: unset;
      }
    }

    &:hover {
      &::before {
        content: none;
      }

      .Material__preview {
        background: #0000004D;
      }
    }

    .Material__actions {
      top: 16px;
      right: 16px;
      transform: none;

      @include mobile {
        display: flex;
        bottom: 0;
        right: 0;
        top: unset;
        transform: none;
      }
    }
  }

  &__name {
    padding-right: 15px;

    @include mobile {
      font-size: 12px;
      font-weight: 600;
      line-height: 17.7px;
    }
  }

  &__line {
    display: flex;
    align-items: center;

    > * + * {
      margin-left: 15px;
    }
  }

  &__mobile-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__preview {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    width: 35px;
    border-radius: 10px;
    background: #CCD7E64D;
  }

  &__image {
    position: relative;
    height: 35px;
    width: 35px;
    border-radius: 10px;
    overflow: hidden;
    background: #CCD7E64D;

    > * {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      filter: brightness(80%);

      @include mobile {
        filter: none
      }
    }

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      @include mobile {
        height: 74px;
        width: 74px;
      }
    }
  }

  &__type {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover & {
    &__actions {
      @include PC {
        display: flex;
      }
    }
  }

  &__actions {
    position: absolute;
    right: -90px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 99;

    display: none;
    align-items: center;

    @include mobile {
      display: flex;
      bottom: 0;
      right: 0;
      top: unset;
      transform: none;
    }
  }

  &__action-button {
    display: inline-flex;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }

    & + & {
      margin-left: 15px;
    }
  }
}
</style>
